module.exports = __webpack_public_path__ + "img/product_solutions.eaa1c9ae.png";